<template>
  <div class="league-countries">
    <template v-for="(key, country) in leagueCountries">
      <span v-if="lang == 'en'" class="tag is-medium is-primary">{{country.en.name}}</span>
      <input v-model="country[lang].name" v-else :value="country[lang].name" :placeholder="country.en.name" class="input" />
    </template>
  </div>
</template>

<script>
import fb from 'firebase'
import _ from 'underscore'

export default {
  props: {
    region: null,
    year: null,
    lang: null
  },
  data: function() {
    return {
      countries: {},
      leagueCountries: []
    }
  },
  ready: function() {
    let self = this

    fb.database().ref('countries').once('value').then(function(snapshot) {
      self.countries = snapshot.val()

      fb.database().ref('countryDataPoints')
      .orderByChild('region')
      .equalTo(self.region)
      .once('value').then(function(snapshot) {
        let regionData = snapshot.val()

        _.each(regionData, function(regionDataPoint) {
          if (regionDataPoint.year == self.year) {
            let key = regionDataPoint.countryKey
            self.leagueCountries.push(self.countries[key])
          }
        })
      })
    })

    this.$on('update', function() {
      if (this.lang != 'en') {
        fb.database().ref('countries').update(this.countries)
      }
    })

  }
}
</script>



/** WEBPACK FOOTER **
 ** LeagueCountries.vue?40e8376c
 **/